module.exports = __webpack_public_path__ + "static/img/ZW_H5.9390c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/ZW_H5.png
// module id = gPRT
// module chunks = 34